import { Text as SlateText } from 'slate';

import { render } from '@react-email/render';

import blocks from '@blocks';
import { transformTheme } from './data';

const renderLeaf = leaf => {
    const {
        bold,
        italic,
        underline,
        strikethrough,
        code,
        text: origonalText,
        ...styles
    } = leaf;

    let text = leaf.text || '\u00A0';

    if (bold) text = <strong>{text}</strong>;
    if (italic) text = <em>{text}</em>;
    if (underline) text = <u>{text}</u>;
    if (strikethrough) text = <del>{text}</del>;
    if (code) text = <code>{text}</code>;
    return <span style={styles}>{text}</span>;
};

const RenderReactEmail = ({ node, editor, mergeTags }) => {
    if (SlateText.isText(node)) {
        return renderLeaf(node);
    }

    const { type, attributes, children: nodeChildren } = node;

    const children = nodeChildren.map((n, i) => (
        <RenderReactEmail
            key={i}
            node={n}
            editor={editor}
            mergeTags={mergeTags}
        />
    ));

    const { PreviewElement } = blocks[type] || {};
    if (!PreviewElement) return children;

    const themedNode = transformTheme(node, editor.children[0].theme);

    return (
        <PreviewElement
            node={themedNode}
            originalNode={node}
            attributes={themedNode.attributes}
            children={children}
            mergeTags={mergeTags}
            editor={editor}
        />
    );
};

const renderHtml = async (node, mergeTags, opts?: any) => {
    const { pretty, replaceMergeTags } = opts || {};
    const html = await render(
        <RenderReactEmail node={node} editor={node} mergeTags={mergeTags} />,
        {
            pretty,
        },
    )
        .then(html => html.replace(/ses-tags=/g, 'ses:tags='))
        .then(html => {
            if (replaceMergeTags) {
                const replaced = html.replace(
                    /{{([\s\S]+?)}}/g,
                    (match, key) => {
                        const trimmedKey = key.trim();
                        return mergeTags[trimmedKey] || '';
                    },
                );
                return replaced;
            }
            return html;
        });

    return html;
};

// const renderReactEmailAsJson = (node, counter = 0) => {
//     if (SlateText.isText(node)) {
//         return renderToStaticMarkup(renderLeafToHtml(node));
//         return renderLeafToHtml(node);
//     }

//     const { type, attributes, children: nodeChildren } = node;

//     const children = nodeChildren.map(n =>
//         renderReactEmailAsJson(n, counter + 1),
//     );

//     const tabs = Array(counter).fill('  ').join('');
//     const prettifiedChildren =
//         '\n'.padEnd(2 + counter * 2, ' ') +
//         children +
//         '\n'.padEnd(counter * 2, ' ');
//     // pretify the children by returning a string with tabs in length of the

//     switch (type) {
//         case 'body':
//             return `<Html {...attributes}>${prettifiedChildren}</Html>`;
//         case 'section':
//             return `<Row {...attributes}>${prettifiedChildren}</Row>`;
//         case 'column':
//             return `<Column {...attributes}>${prettifiedChildren}</Column>`;
//         case 'button':
//             return `<Button {...attributes}>${prettifiedChildren}</Button>`;
//         case 'image':
//             return `<Img {...attributes} />`;
//         case 'rich-text':
//             return `<Text {...attributes}>${prettifiedChildren}</Text>`;
//         case 'paragraph':
//             return `<p {...attributes}>${prettifiedChildren}</p>`;
//         case 'block-quote':
//             return `<blockquote {...attributes}>${prettifiedChildren}</blockquote>`;
//         case 'bulleted-list':
//             return `<ul {...attributes}>${prettifiedChildren}</ul>`;
//         case 'heading-one':
//             return `<h1 {...attributes}>${prettifiedChildren}</h1>`;
//         case 'heading-two':
//             return `<h2 {...attributes}>${prettifiedChildren}</h2>`;
//         case 'list-item':
//             return `<li {...attributes}>${prettifiedChildren}</li>`;
//         case 'numbered-list':
//             return `<ol {...attributes}>${prettifiedChildren}</ol>`;
//         case 'link':
//             return `<a href={node.url} {...attributes}>
//                     ${prettifiedChildren}
//                 </a>`;
//         case 'soft-break':
//             return ` <br />`;
//         default:
//             return children;
//     }
// };

export { renderHtml };
